import { Controller } from "@hotwired/stimulus";
import AutoNumeric from "autonumeric";

// Connects to data-controller="input-masking"
export default class extends Controller {
  static values = { mask: String, max: Number };

  connect() {
    this.initializeMask();

    this.updateListener = this.updateAutoNumeric.bind(this);
    this.element.addEventListener("change", this.updateListener);

    setTimeout(() => {
      if (this.element.value && this.autoNumeric) {
        this.autoNumeric.set(this.element.value);
      }
    }, 100);

    const form = this.element.closest("form");
    if (form) {
      this.submitListener = this.formatBeforeSubmit.bind(this);
      form.addEventListener("submit", this.submitListener);
    }
  }

  disconnect() {
    const form = this.element.closest("form");
    if (form && this.submitListener) {
      form.removeEventListener("submit", this.submitListener);
    }
    this.element.removeEventListener("change", this.updateListener);
  }

  initializeMask() {
    let options = {};

    if (this.hasMaxValue) {
      options.maximumValue = this.maxValue.toString();
    }

    switch (this.maskValue) {
      case "amount":
        options = {
          digitGroupSeparator: ",",
          decimalPlaces: 0,
          allowDecimalPadding: false,
          maximumValue: "99999999999999",
          minimumValue: "0",
          decimalCharacter: ".",
          alwaysAllowDecimalCharacter: false,
          modifyValueOnWheel: false,
          wheelStep: "1",
          roundingMethod: "U",
          forcedDecimalPlaces: true,
        };
        break;
      case "dollars_and_cents":
        options = {
          currencySymbol: "$",
          digitGroupSeparator: ",",
          decimalCharacter: ".",
          decimalPlaces: 2,
          maximumValue: "99999999999999",
          minimumValue: "0",
        };
        break;
      case "dollars":
        options = {
          currencySymbol: "$",
          digitGroupSeparator: ",",
          decimalCharacter: ".",
          decimalPlaces: 0,
          maximumValue: "99999999999999",
          minimumValue: "0",
        };
        break;
      case "percentage":
        options = {
          suffixText: "%",
          digitGroupSeparator: ",",
          decimalCharacter: ".",
          decimalPlaces: 2,
          maximumValue: "100",
          minimumValue: "0",
        };
        break;
    }

    this.autoNumeric = new AutoNumeric(this.element, options);
  }

  updateAutoNumeric() {
    if (this.element.value && this.autoNumeric) {
      this.autoNumeric.set(this.element.value);
    }
  }

  getRawValue() {
    return this.autoNumeric ? this.autoNumeric.getNumber() : null;
  }

  formatBeforeSubmit(event) {
    const rawValue = this.getRawValue();
    if (rawValue !== null) {
      this.element.value = rawValue;

      if (this.hasMaxValue && rawValue > this.maxValue) {
        event.preventDefault();
        this.element.setCustomValidity(`Value cannot exceed ${this.maxValue}`);
        this.element.reportValidity();
      } else {
        this.element.setCustomValidity("");
      }
    }
  }
}
